<template>
    <div
            :class="['tab', {active: isActive, editable: tab.editable, open: menuIsVisible, 'with-new': tab.newLots > 0}]"
            :style="{'--tag-color': tags.find(t => t.id === tab.id)?.color, '--tag-width': tab.filterType === 'TAG' ? 'max-content': ''}"
    >
        <button
                :class="['tab-btn', {disabled: isRequesting || (!authorities.includes('ROLE_SUBSCRIBED_USER') && tab.filterType === 'GENERAL')}]"
                type="button"
                @click="onChangeTab(tab)"
                :title="
                        !authorities.includes('ROLE_SUBSCRIBED_USER') &&
                        tab.name !== 'Все' &&
                        tab.name !== 'Избранные' &&
                        tab.name !== 'Скрытые'
                            ? 'Доступно при наличии платной подписки'
                            : ''
                        "
        >
            <span>{{tab.name ? tab.name : "Метки"}}</span>
        </button>

        <div v-if="tab.newLots" class="tab-counter">+ {{tab.newLots}}</div>

        <div
                v-if="tab.editable"
                class="tab-menu-wrapper"
                @focusout="closeMenu"
        >
            <button
                    class="tab-btn-more"
                    type="button"
                    @click.stop="menuIsVisible = !menuIsVisible"
                    :disabled="!authorities.includes('ROLE_SUBSCRIBED_USER')"
            >
                <span v-if="isActive || menuIsVisible" key="active">
                    <ico name="icoMoreVert" color="#263239"/>
                </span>
                <span v-else key="simple">
                    <ico name="icoMoreVert" color="#79919C"/>
                </span>
            </button>
            <TabMenu v-if="menuIsVisible && authorities.includes('ROLE_SUBSCRIBED_USER')"
                     :filter-tab="tab"
                     @closeMenu="closeMenu"
            />
        </div>
    </div>
</template>

<script>
    import TabMenu from '@/components/common/TabMenu';
    import {mapGetters, mapActions} from "vuex";
    import { showSubscriptionToast } from "@/services/subscriptionNotification";

    export default {
        name: "Tab",
        data() {
            return {
                menuIsVisible: false
            }
        },
        props: ['isActive', 'tab'],
        components: {
            TabMenu
        },
        computed: {
            ...mapGetters('auth', ['authorities']),
            ...mapGetters('purchases', ['isRequesting']),
            ...mapGetters('profile', ['profileId']),
            ...mapGetters('subscriptions', ['subscriptions']),
            ...mapGetters('tags', ['tags']),
            getTooltip() {

                return (this.authorities.includes('ROLE_SUBSCRIBED_USER') || this.tab.filterType !== 'GENERAL') ?
                    this.tab.name :
                    'Настраиваемые фильтры доступны только при наличии платной подписки'
            }
        },
        methods: {
            ...mapActions('subscriptions', ['getSubscriptions']),
            closeMenu() {
                setTimeout(() => {
                    this.menuIsVisible = false
                }, 200)
            },
            async onChangeTab(tab) {
                const isInitialTab = ['FAVORITES', 'HIDDEN', 'ALL'].includes(tab.filterType);

                if (this.authorities.includes('ROLE_SUBSCRIBED_USER') || isInitialTab) {
                    this.$emit('onChangeTab', tab);
                    return;
                }

                await this.getSubscriptions(this.profileId);
                showSubscriptionToast(this.subscriptions, this.$toast);
            },
        }
    }
</script>

<style lang="less" scoped>
    @import '../../assets/less/variables.less';

    .tab {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: @br;
        padding: 0 8px;
        transition: background-color 0.4s linear;
        &.editable {
            padding-right: 24px;
        }

        &::after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            bottom: -1px;
            z-index: 2;
            height: 2px;
            background-color: var(--tag-color, @text-color-light);
            opacity: 0;
            transition: @trans;
        }

        &-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 8px;
            height: 47px;

            span {
                overflow: hidden;
                max-width: var(--tag-width, 104px);
                font-weight: 500;
                font-size: 13px;
                letter-spacing: 0.25px;
                color: @text-color-light;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        &-menu-wrapper {
            visibility: hidden;
            position: absolute;
            top: 0;
            bottom: 0;
            right: 0;
            z-index: 2;
            display: flex;
            align-items: center;
            opacity: 0;
        }

        &-btn-more {
            padding-top: 4px;
        }

        &-counter {
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 12px;
            padding: 0 4px;
            height: 24px;
            font-size: 12px;
            white-space: nowrap;
            color: @text-color-light;
            background-color: @bg-color-light;
        }

        &.active {
            .tab-btn span {
                color: @text-color;
            }

            &::after {
                opacity: 1;
            }
        }

        &:hover {
            background-color: fade(@bg-color-light, 50%);

            .tab-tooltip {
                visibility: visible;
                opacity: 1;
            }
        }

        &.editable:hover,
        &.editable.open {

            .tab-menu-wrapper {
                visibility: visible;
                opacity: 1;
            }
        }

        &.editable.with-new:hover {

            .tab-menu-wrapper {
                visibility: visible;
                opacity: 1;
            }
        }

        &-btn.disabled {
            opacity: 0.6;
        }
    }

    .tab-tooltip {
        visibility: hidden;
        position: absolute;
        left: 0;
        top: calc(100% + 2px);
        z-index: 10;
        border-radius: @br;
        padding: 4px 8px;
        max-width: 300px;
        font-size: 13px;
        letter-spacing: 0.3px;
        color: #ffffff;
        background-color: fade(@text-color-light, 90%);
        opacity: 0;
        transition: opacity 0.4s linear;
    }
</style>
